export default "__VITE_ASSET__2696c4a3__"